import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
/** `POST …/lists/{list}/items` — the list key travels in the URL (`encodeURIComponent`, applied by the
 * caller); `position` is the 0-indexed rank the new item takes. */
class AddDocumentListItem {
	constructor(
		public readonly facilityId: number,
		public readonly subject: SubjectAddress,
		public readonly documentId: number,
		public readonly listKey: string,
		public readonly position: number,
	) {
		Object.freeze(this);
	}

	toJSON(): { position: number } {
		return { position: this.position };
	}
}

export default AddDocumentListItem;
